import { telegramMock } from "telegram.consts";

export const CommonUtil = () => {

    const arrayRange = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    const randomFloat = (min, max) => (Math.random() * (max - min + 1)) + min;
    const randomInteger = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
    const randomNum = (min, max) => Math.max((Math.random() * max), min).toFixed(1);

    const getUrlSearchParameter = (name) => {
        name = (new RegExp("[?&]" + encodeURIComponent(name) + "=([^&]*)")).exec(window.location.search);
        if (name) {
            return decodeURIComponent(name[1]);
        }

        return "";
    };

    const getWidth = () => document.documentElement.clientWidth  || document.body.clientWidth  || window.innerWidth;

    const getHeight = () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    const setWindowSize = webApp => {
        const root = document.documentElement,
            width  = getWidth(),
            height = getHeight(),
            viewportHeight = webApp.viewportStableHeight;
        root.style.setProperty('--window-width', width + 'px');
        root.style.setProperty('--window-height', height + 'px');
        root.style.setProperty('--window-width-ratio', String(width / 393));
        root.style.setProperty('--window-height-ratio', String(height / 820));

        const show = getUrlSearchParameter('show');
        if (show === 'ss') {
            let ss = document.querySelector('.app-debug-screen-size');
            if (!ss) {
                ss = document.createElement('div');
                ss.classList.add('app-debug-screen-size');
                document.body.prepend(ss);
            }
            ss.innerHTML = width + ' x ' + height + ' [' + viewportHeight + (webApp.isExpanded ? ', expanded' : '') + ', platform: ' + (webApp.platform || 'unknown') + ']';
        }
    }

    const getRandom = (min, max) => {
        return Math.floor(Math.random() * (max - min) + min);
    }

    const showAlert = message => {
        const webApp = window.Telegram.WebApp;
        if (webApp && webApp.isVersionAtLeast('6.2')) {
            webApp.showAlert(message);
        } else {
            alert(message);
        }
    }

    const isEmptyObject = obj => {
        if (null === obj || typeof obj !== "object") {
            return true;
        }

        return !Object.keys(obj).length;
    }

    const isTouchDevice = () => {
        return "ontouchstart" in document.documentElement;
    }

    const hashString = string => {
        let hash = 0, i, chr;
        if (string.length === 0) return hash;
        for (i = 0; i < string.length; i++) {
            chr = string.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

    /*** *** *** *** *** *** *** ***/

    const ymReachGoal = target => {
        if (typeof ym !== 'undefined') {
            // ym(98376842, 'reachGoal', target);
            console.log('[YM.ReachGoal] > ' + target);
        }
    }

    const ymHit = uri => {
        if (typeof ym !== 'undefined') {
            // ym(98376842, 'hit');
            console.log('[YM.Hit] > ' + uri);
        }
    }

    /*** *** *** *** *** *** *** ***/

    return {
        arrayRange,
        getHeight,
        getRandom,
        getUrlSearchParameter,
        getWidth,
        randomFloat,
        randomInteger,
        randomNum,
        setWindowSize,
        showAlert,
        isEmptyObject,
        isTouchDevice,
        hashString,
        ymReachGoal,
        ymHit
    }
}